
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'
import 'vuetify/src/stylus/app.styl'
import manifest from '@/../public/manifest.json'
import i18n from '@/locale'

Vue.use(Vuetify, {
  theme: {
    primary: manifest.theme_color,
    secondary: colors.purple.darken4,
    tertiary: colors.purple.lighten5,
    accent: colors.cyan.accent4,
    error: colors.red.base,
    warning: colors.amber.base,
    info: colors.blue.base,
    success: colors.green.base
  },
  iconfont: 'md',
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})
